import { isDefined } from 'notable-common';
import { z } from 'zod';
import { DomainSchema } from '../common/domain.js';
export var OrganizationTrialStatus;
(function (OrganizationTrialStatus) {
    OrganizationTrialStatus["Active"] = "Active";
    OrganizationTrialStatus["Revoked"] = "Revoked";
    OrganizationTrialStatus["Converted"] = "Converted";
})(OrganizationTrialStatus || (OrganizationTrialStatus = {}));
const OrganizationTrialStatusSchema = z.enum(OrganizationTrialStatus);
const UniqueDomainArraySchema = z
    .array(DomainSchema)
    .min(1)
    .refine((domains) => new Set(domains.map((domain) => domain.toLowerCase())).size === domains.length, { message: 'Domains must be unique' });
export const OrganizationTrialCreateBodySchema = z
    .object({
    organizationId: z.uuid(),
    domains: UniqueDomainArraySchema,
})
    .strict();
const StatusTransitionSchema = z
    .object({
    status: z.enum([OrganizationTrialStatus.Revoked, OrganizationTrialStatus.Converted]),
})
    .strict();
const DomainChangesSchema = z
    .object({
    domainsToAdd: UniqueDomainArraySchema.optional(),
    domainsToRemove: z.array(z.string().min(1)).min(1).optional(),
})
    .strict()
    .refine((body) => isDefined(body.domainsToAdd) || isDefined(body.domainsToRemove), {
    message: 'At least one of domainsToAdd or domainsToRemove must be provided',
});
export const OrganizationTrialUpdateBodySchema = z.union([
    StatusTransitionSchema,
    DomainChangesSchema,
]);
export const OrganizationTrialIdParamsSchema = z.object({ organizationTrialId: z.uuid() }).strict();
export const OrganizationTrialFindAllQuerySchema = z
    .object({
    organizationId: z.uuid().optional(),
    status: OrganizationTrialStatusSchema.optional(),
})
    .strict();
//# sourceMappingURL=organizationTrial.js.map